import {Component, Input, OnChanges, SimpleChanges,} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup} from '@angular/forms';
import {Field} from '../../../../interfaces';

@Component({
    selector: 'app-form-input-multi-checkbox',
    templateUrl: './form-input-multi-checkbox.component.html',
    styleUrls: ['./form-input-multi-checkbox.component.scss'],
    standalone: false
})
export class FormInputMultiCheckboxComponent {
  @Input() control: FormGroup;

  @Input() field: Field<number>;

  keys(item: {}) {
    return Object.keys(item);
  }

  // True when DoberAvto flagged this item as optional (installed === SOMETIMES)
  // for this vehicle — rendered as an unchecked "optional" pill.
  isOptional(item: {}): boolean {
    return this.field?.config?.suggestedItems?.includes(this.keys(item)[0]) ?? false;
  }

  asFormGroup(control: any): FormGroup {
    return control as FormGroup;
  }
}
